import { PRELOADER_START, PRELOADER_FINISH } from 'actions/types';

export function startPreloader() {
  return Promise.resolve({
    type: PRELOADER_START,
    payload: true
  });
}

export function finishPreloader() {
  return Promise.resolve({
    type: PRELOADER_FINISH,
    payload: false
  });
}



// WEBPACK FOOTER //
// ./src/actions/preloader.js